import _createForOfIteratorHelper from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import { Card } from "./models/index.js";
import r from "../managers/braze-instance.js";
import { isArray as D } from "../util/code-utils.js";
import E from "../../shared-lib/logger.js";
import { MUST_BE_CARD_WARNING_SUFFIX as Q } from "../common/constants.js";
import G from "./card-manager-factory.js";
export function logContentCardImpressions(o) {
  if (!r.rr()) return !1;
  if (!D(o)) return E.error("cards must be an array"), !1;
  var _iterator = _createForOfIteratorHelper(o),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _r = _step.value;
      if (!(_r instanceof Card)) return E.error("Each card in cards ".concat(Q)), !1;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return G.ea().Ot(o).W;
}